export const handleError = (error) => {
  console.log("Err", error.response);
  let errorMessage = "";

  if (error.message) errorMessage += error.message;

  if (error.response && error.response.data) {
    errorMessage += error.response.data.message;
  }
  console.log(errorMessage);
};
export default handleError;
